(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('ObsService', ObsService);

    ObsService.$inject = ['SoopkitchenUtils', '$http'];

    function ObsService(SoopkitchenUtils, $http) {

        return {
            moveObs: moveObs,
        };

        function successMoveObs(observations, time, cut, extraCallback) {
            return function (response) {
                var verb = 'copied';
                if (cut) verb = 'moved';
                var title = "Observations have been " + verb;
                var msg = observations.length + " have been " + verb + " to " + time;
                SoopkitchenUtils.processResponse(
                    response,
                    title,
                    msg,
                    extraCallback(response)
                );
            }
        }

        function failureMoveObs(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function moveObs(planType, planLabel, observations, anchorTime, cut, successCallback) {
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/obsInstance/copy',
                params: {
                    'planLabel': planLabel,
                    'anchorDate': anchorTime,
                    'cut': cut
                },
                data: observations 
            }).then(successMoveObs(observations, anchorTime, cut, successCallback), failureMoveObs);
        }

    }
})();
